/*global define*/

define([
    'jquery',
    'underscore',
    '../Configuration',
    'backbone',
    'bootstrap',
    '../util/clamp',
    'interactjs'
], function ($, _, Configuration, Backbone, bootstrap, clamp, interact) {
    'use strict';


    var VesselView = Backbone.View.extend({
        contextMenuOpen: false,
        tagName: 'div',
        events: {
            'contextmenu': 'openContextMenu'
        },
        render: function(){
            const menu = `<span class="glyphicon glyphicon-menu-hamburger openContextMenu"></span>`
            this.$el.html(menu+this.template({
                name: this.model.attributes.name,
                cid: this.model.cid,
                color: this.model.attributes.color,
                solidColor: this.model.attributes.solidColor,
                volume: this.model.attributes.volume,
                solidVolume: this.model.attributes.solidVolume,
                pour: this.model.attributes.pour,
                accept: this.model.attributes.accept,
                offset: this.model.attributes.vessel.offset,
                temperature: this.model.attributes.temperature,
                pH: this.model.attributes.pH,
                description: this.model.attributes.description,
                volumeString: this.model.attributes.volumeString,
                detailView: this.model.attributes.detailView,
                showVesselStats: Configuration.showVesselStats
            }));
            var winWidth =  $("#vlab").width();
            var scaleFactor = 1;
            if(winWidth < 768 ){
                scaleFactor = .5;
            }else if( winWidth >= 768 && winWidth <= 991){
                scaleFactor = .75;
            }else if( winWidth >= 992 && winWidth <= 1199){
                scaleFactor = 7/8;
            }
            scaleFactor *= Configuration.userScaleFactor;
            var svg = this.$el.find("svg");
            var width = svg.attr("width");
            svg.attr("width", width * scaleFactor);
            var height = svg.attr("height");
            svg.attr("height", height * scaleFactor);
            this.$el.css("position", "absolute");
            this.$el.width("auto");
            this.$el.height("auto");
            if (this.model.get('draggable')) {
                this.$el.addClass('draggable');
            } else {
                this.$el.removeClass('draggable');
            }
            if (this.model.get('hasTool')) {
                this.$el.css('zIndex', 10)
            }
            
            this.$el.bind("contextmenu", this.openContextMenu.bind(this));
/*
            var path = this.$el.find("path");
            path.css("stroke-width", 1);
*/
            var cid = this.model.cid;
            if (this.model.get("hasTool") || this.model.get("pour")) {
                var info = $(".vesselInfo", "#" + cid);
                info.remove();
                info.prependTo("#" + cid);
            }
        },
        openContextMenu: function(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.contextMenuOpen = true;
            console.log('Opening context menu...')
            /*$(".removeSolid").attr("id", cid);
            $(".removeLiquid").attr("id", cid);
            $(".duplicateVessel").attr("id", cid);
            $(".thermalProperties").attr("id", cid);
            $(".renameVessel").attr("id", cid);
            $(".removeVessel").attr("id", cid);*/
            $(".workbenchContextMenu").css("display", "none");
            if (this.model.get("vessel").hasDetailView) {
                $(".detailViewGroup").css("display", "block");
                var checkmark = $(".detailView").find(".glyphicon");
                if (this.model.get("detailView")) {
                    checkmark.css("display","inline-block");
                }
                else {
                    checkmark.css("display","none");
                }
            }
            else $(".detailViewGroup").css("display", "none");
            var menu = $(".vesselContextMenu");
            menu.css({
                display: "block",
                top: (event.pageY < $(window).height() / 2) ? event.pageY : event.pageY - menu.height(),
                left: (event.pageX < $(window).width() / 2) ? event.pageX : event.pageX - menu.width()
            });
            setTimeout(() => {
                $(document).one('click', () => {
        
                    $(".contextMenu").hide();
                    this.contextMenuOpen = false;
                });
            }, 400)
        },
        initialize: function(){
            // this.template = require("ejs!" + this.model.attributes.vessel.template);
            //var temp1 = require('ejs-loader!../templates/250mLFlask.ejs');
            //var temp2 = require('ejs-loader!../templates/3LCarboy.ejs');
            var name = this.model.attributes.vessel.template;

            console.log(name)
            // Switch this to an object with the key being the name of the vessel and the value being the template

            const nameNewDirectory =  name.replace('app/scripts/', '');
            console.log(nameNewDirectory)

            const vesselNames = [
              '3LCarboy',
              '5mLPipette',
              '10mLPipette',
              '25mLPipette',
              '10mLGraduatedCylinder',
              '25mLGraduatedCylinder',
              '50mLGraduatedCylinder',
              '50mLBurette',
              '100mLBottle',
              '2500mLBottle',
              '100mLVolumetricFlask',
              '250mLVolumetricFlask',
              '500mLVolumetricFlask',
              '1000mLVolumetricFlask',
              '250mLStopperedFlask',
              '250mLFlask',
              '500mLFlask',
              '1000mLFlask',
              '250mLBeaker',
              '600mLBeaker',
              '1000mLBeaker',
              'DisposablePipette',
              'foamCup',
              'solidBottle',
              'weighBoat',
              'Vessel'
            ];
            
            // Any issues with this?

            this.x = 0;
            this.y = 0;

            this.template = require(`ejs-loader!../${nameNewDirectory}`);
            this.$el.attr('id', this.model.cid);
            this.$el.addClass("vessel");
            // draggable should be stored in the model...
            
            // Only need to do this once...
            this.setDragAndDrop();

            _.bindAll(this, "render");
            this.model.bind('change', this.render);
        },
        startDrag: function (event) {
            this.el.classList.add('dragged')
            const x = parseFloat(event.target.style.left.replace('px', ''));
            const y = parseFloat(event.target.style.top.replace('px', ''));
            this.x = isNaN(x) ? this.x : x;
            this.y = isNaN(y) ? this.y : y;
            
            this.xMin = 0
            this.xMax = this.$el.parent().width() - this.$el.width();
            this.yMin = 0
            this.yMax = this.$el.parent().height() - this.$el.height();
        },

        endDrag: function (event) {
            this.el.classList.remove('dragged');
        },

        moveDrag: function (event) {
            this.x += event.dx;
            this.y += event.dy;
            
            const xDisplay = clamp(this.x, this.xMin, this.xMax);
            const yDisplay = clamp(this.y, this.yMin, this.yMax);
            
            this.el.style.left = `${xDisplay}px`;
            this.el.style.top = `${yDisplay}px`;
          },
        tap: function (event) {
                const rect = this.el.getBoundingClientRect()
                const x = event.clientX;
                const y = event.clientY;
                if (this.el.classList.contains('selectedVessel') && (Math.abs(x - rect.right) < 30) && 
                            (Math.abs(rect.top-y) < 30)) {
                    console.log('Opening context menu')
                    this.openContextMenu(event);
                } else {
                    console.log('normal tap: Distance from Right, Top = ')
                    console.log(Math.abs(rect.right-x))
                    console.log(Math.abs(y - rect.top))
                }
            },
        
        setDragAndDrop: function(){
            // this.$el.draggable({
            //     opacity: 0.6,
            //     scroll: false,
            //     stack: ".flask",
            //     scope: "workbench",
            //     containment: "parent"
            // });
            // The on hold stuff doesn't work now...
            this.interaction = interact(`#${this.el.id}.draggable`).draggable({
                listeners: {
                    start: this.startDrag.bind(this),
                    end: this.endDrag.bind(this),
                    move: this.moveDrag.bind(this)
                }
            })
            .styleCursor(false)
            .on('tap', this.tap.bind(this));
    

            // this.$el.droppable({
            //     accept: "div",
            //     scope: "workbench",
            //     // I would need to add this 'drag-hover' class...
            //     hoverClass: "drag-hover",
            //     tolerance: "pointer"
            // });

        },
    });

    return VesselView;
});
